export { getEffectiveAspectRatio } from './camera.js';

const FULL_VIEWPORT = { x: 0, y: 0, width: 1, height: 1 };
function clamp01(value) {
  return Math.max(0, Math.min(1, value));
}
function resolveCameraViewport(camera, targetWidth, targetHeight) {
  const v = camera?.viewport ?? FULL_VIEWPORT;
  const x0 = clamp01(v.x);
  const y0 = clamp01(1 - v.y - v.height);
  const x1 = clamp01(v.x + v.width);
  const y1 = clamp01(1 - v.y);
  const x = Math.floor(x0 * targetWidth);
  const y = Math.floor(y0 * targetHeight);
  const width = Math.max(0, Math.ceil(x1 * targetWidth) - x);
  const height = Math.max(0, Math.ceil(y1 * targetHeight) - y);
  return { x, y, width, height };
}

export { FULL_VIEWPORT, resolveCameraViewport };
//# sourceMappingURL=viewport.js.map
